import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { withTrackingParams } from '../utils/trackingParams';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
  variant?: 'gold' | 'dark';
  showArrow?: boolean;
}

/** Checkout oficial y único de 200 Fórmulas de Jabones Artesanales de Glicerina. */
export const CHECKOUT_URL = 'https://200-jabones-artesanales.impultienda.ar/checkout';
export function CTAButton({
  label = 'SÍ, QUIERO COMPRAR EL PACK COMPLETO',
  className = '',
  href = CHECKOUT_URL,
  variant = 'gold',
  showArrow = true
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const finalHref = goesToCheckout ? withTrackingParams(href) : href;
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!goesToCheckout) return;
    // Se recalcula al hacer clic por si los parámetros se guardaron después
    // del render.
    event.currentTarget.href = withTrackingParams(href);
    trackInitiateCheckout();
  };
  const palette = variant === 'dark' ? 'bg-charcoal text-white hover:bg-charcoal-soft focus-visible:ring-charcoal/40' : 'cta-gradient text-white shadow-[0_14px_30px_-10px_rgba(106,63,184,0.55)] hover:shadow-[0_18px_38px_-12px_rgba(106,63,184,0.65)] focus-visible:ring-gold/40';
  return <a href={finalHref} onClick={handleClick} className={cn('group inline-flex min-h-[58px] items-center justify-center gap-2.5 rounded-xl px-7 py-4 text-center font-display text-[0.95rem] font-bold uppercase leading-tight tracking-[0.03em] transition-[transform,box-shadow,background-color] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4', palette, className)} data-id="element-49" data-mp="1s8k65jc3z82w">
      {label}
      {showArrow && <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden strokeWidth={2.5} data-id="element-50" data-mp="2fwjy2ml5p4j2" />}
    </a>;
}